import React from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import queryString from 'query-string';
import { useErrorBoundary } from 'react-error-boundary';
import {
  getExpiringLocalStorage,
  setExpiringLocalStorage,
  useAuth,
} from '@front-activerse/common-components';

interface ICartAddContainer {
  savePaymentProduct: (productId: number, promoCode?: string, source?: string) => Promise<any>;
  pathCartSignUp: string;
  pathCartSavePayment: string;
}

const EXPIRING_PROMOCODE_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
const EXPIRING_SOURCE_MS = 24 * 60 * 60 * 1000; // 24h

const CartAddContainer: React.FC<ICartAddContainer> = ({
  savePaymentProduct,
  pathCartSignUp,
  pathCartSavePayment,
}) => {
  const { productId } = useParams();
  const { showBoundary } = useErrorBoundary();
  const navigate = useNavigate();
  const { isAuth } = useAuth();

  const queryStringObject = queryString.parse(global.location.search);
  const promoCode = String(queryStringObject.pc);
  const source = String(queryStringObject.source);

  if (source && source !== 'undefined') {
    setExpiringLocalStorage('saleSource', source, EXPIRING_SOURCE_MS);
  }

  if (promoCode && promoCode !== 'undefined') {
    setExpiringLocalStorage('promoCode', promoCode, EXPIRING_PROMOCODE_MS);
  }

  const handleSavePayment = async () => {
    try {
      const response = await savePaymentProduct(
        Number(productId),
        promoCode,
        getExpiringLocalStorage('saleSource')
      );

      // success
      if (response.data.sale.savePaymentProducts.__typename === 'Payment') {
        const shoppingCartToken = response.data.sale.savePaymentProducts.token;
        localStorage.setItem('shoppingCartToken', shoppingCartToken);
        localStorage.setItem('shopppingCartProductId', String(productId));
        localStorage.setItem(
          'shoppingCartProducts',
          JSON.stringify(response.data.sale.savePaymentProducts.products)
        );

        if (isAuth) {
          navigate(pathCartSavePayment);
        } else {
          navigate(pathCartSignUp);
        }
      } else {
        showBoundary(response.data);
      }
    } catch (err) {
      showBoundary(err);
    }
  };
  useEffect(() => {
    handleSavePayment();
  }, []);

  return null;
};

export default CartAddContainer;
